import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infractions',
  templateUrl: './infractions.component.html',
  styleUrls: ['./infractions.component.css'],
})
export class InfractionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
